import { FC } from "react";
import classNames from "classnames";
import * as RadixTooltip from "@radix-ui/react-tooltip";

import { TooltipProps } from "./types";

import styles from "./Tooltip.module.css";



const Tooltip: FC<TooltipProps> = ({
  content,
  children,
  side = "top",
  sideOffset = 6,
  delayDuration = 100,
  contentClassName,
}) => (
  <RadixTooltip.Provider delayDuration={delayDuration}>
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>
        {children}
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className={classNames(styles["tooltip_content"], contentClassName)}
          side={side}
          sideOffset={sideOffset}
        >
          {content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  </RadixTooltip.Provider>
);

export default Tooltip;
